import React from 'react';
import { CurrencyText } from '@nile/components';
import { TextStyle } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import { getCellValue } from '../../../util';

function CurrenyHourCell(props) {
  const { cell } = props;
  const { column, row } = cell;

  const value = getCellValue(row?.original, column?.accessorKey);
  return (
    <div className="ellipsis">
      {value ? (
        <CurrencyText
          value={value}
          config={{ notation: 'compact' }}
          perValue={column?.type === 'CURRENCY_HOUR'}
        />
      ) : (
        <TextStyle variation="subdued">
          <FormattedMessage id="app.noData.message" />
        </TextStyle>
      )}
    </div>
  );
}

export default CurrenyHourCell;
